import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EvaluationSchema = withDefaults({
  type: 'evaluation',
  objectExtensions: ['evaluation'],
  fields: [
    {
      kind: 'attribute',
      name: 'actorDecision',
    },
    {
      kind: 'attribute',
      name: 'agreement',
    },
    {
      kind: 'attribute',
      name: 'recommendationOutcome',
    },
    {
      kind: 'attribute',
      name: 'evaluationMetadata',
    },
    {
      kind: 'attribute',
      name: 'recommendableType',
    },
    {
      kind: 'attribute',
      name: 'recommendableId',
    },
    {
      kind: 'attribute',
      name: 'actorType',
    },
    {
      kind: 'attribute',
      name: 'actorId',
    },
    {
      kind: 'attribute',
      name: 'initiatorType',
    },
    {
      kind: 'attribute',
      name: 'initiatorId',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'aiRecommendation',
      type: 'ai-recommendation',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default EvaluationSchema;
